import type React from 'react'
import { useState } from 'react'
import { ChevDownIcon } from '../icons'
import { cn } from '../lib/cva'
import { Text } from './Text'

interface CollapsibleSectionProps {
	title: React.ReactNode
	children: React.ReactNode
	className?: string
	defaultOpen?: boolean
	isOpen?: boolean
	onToggle?: (isOpen: boolean) => void
}

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
	title,
	children,
	className,
	defaultOpen = false,
	isOpen: controlledIsOpen,
	onToggle,
}) => {
	const [isOpen, setIsOpen] = useState(Boolean(defaultOpen))
	const open = controlledIsOpen ?? isOpen

	const toggleCollapse = () => {
		if (controlledIsOpen === undefined) {
			setIsOpen(!open)
		}
		onToggle?.(!open)
	}

	return (
		<div className={cn('space-y-2', className)}>
			<button type='button' className='flex items-center cursor-pointer' onClick={toggleCollapse}>
				{typeof title === 'string' ? (
					<Text variant='large' weight='semibold'>
						{title}
					</Text>
				) : (
					title
				)}
				<ChevDownIcon
					size={16}
					className={cn('ml-2 transition-transform duration-300', {
						'rotate-90': open,
					})}
				/>
			</button>

			{open && <div>{children}</div>}
		</div>
	)
}
